import {Injectable} from '@angular/core'
import {HttpClient, HttpParams} from '@angular/common/http'

import {Observable} from 'rxjs'
import {tap} from 'rxjs/operators'

import {LoggerService} from '@app/core/services/logger.service'

import {ApiSearchRequest, ApiSearchResponse} from '../api.interface'
import {User, Role, Permission} from '../rest-api.model'

export {User, Role, Permission}

export interface GetUsersRequest extends ApiSearchRequest {
  domain: string
}
export interface GetUsersResponse extends ApiSearchResponse<User> {}
export interface UpdateUserRolesRequest {
  roleIds: number[]
}
export interface CreateUserRequest extends User {
  roleIds: number[]
  sendEmail: boolean
}

@Injectable({providedIn: 'root'})
export class UserService {
  deactivate(domain: string, userID: number): Observable<any> {
    const url = `api://Domains/${domain}/Users/${userID}/disable`

    return this.http.post<GetUsersResponse>(url, {}).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  constructor(
    private http: HttpClient,
    private logger: LoggerService,
  ) {}

  public getUsers(request: GetUsersRequest): Observable<GetUsersResponse> {
    const url = 'api://Domains/' + request.domain + '/Users'

    console.log(request, 'request')
    // convert all object properties to strings
    let params = new HttpParams()
    if (request.search) {
      params = params.set('search', request.search)
    }
    if (request.sort) {
      params = params
        .set('sort', request.sort)
        .set('asc', !request.asc ? 'false' : 'true')
    }
    if (request.offset) {
      params = params.set('offset', request.offset.toString())
    }
    if (request.results) {
      params = params.set('results', request.results.toString())
    }

    return this.http.get<GetUsersResponse>(url, {params: params}).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public getUser(domain: string, id: number): Observable<User> {
    const url = 'api://Domains/' + domain + '/Users/' + id

    return this.http.get<User>(url).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public postUser(domain: string, user: CreateUserRequest): Observable<User> {
    const url = 'api://Domains/' + domain + '/Users'

    return this.http.post<User>(url, user).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public putUser(domain: string, id: number, user: User): Observable<User> {
    const url = 'api://Domains/' + domain + '/Users/' + id

    return this.http.put<User>(url, user).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public deleteUser(domain: string, id: number): Observable<void> {
    const url = 'api://Domains/' + domain + '/Users/' + id

    return this.http.delete<void>(url)
  }

  public getAvailableRoles(domain: string): Observable<Role[]> {
    const url = 'api://Domains/' + domain + '/Users/AvailableRoles'

    return this.http.get<Role[]>(url).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public getUserRoles(domain: string, id: number): Observable<Role[]> {
    const url = 'api://Domains/' + domain + '/Users/' + id + '/Roles'

    return this.http.get<Role[]>(url).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public putUserRoles(
    domain: string,
    id: number,
    request: UpdateUserRolesRequest,
  ): Observable<Role[]> {
    const url = 'api://Domains/' + domain + '/Users/' + id + '/Roles'

    return this.http.put<Role[]>(url, request).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public getUserPermissions(
    domain: string,
    id: number,
  ): Observable<Permission[]> {
    const url = 'api://Domains/' + domain + '/Users/' + id + '/Permissions'

    return this.http.get<Permission[]>(url).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public setUserData(
    domain: string,
    userId: string,
    request: any,
  ): Observable<any> {
    const url = `api://Domains/${domain}/Users/${userId}/setData`
    return this.http.put<any>(url, request)
  }
}
